import { useEffect, useState } from 'react'

const useKioskParameterOpening = (instanceId?: string): number => {
  const [current, setCurrent] = useState<number>(0)

  const handleChange = (e: CustomEvent): void => {
    if (instanceId) {
      e.detail.instanceId === instanceId && setCurrent(e.detail.value)
    } else {
      setCurrent(e.detail.value)
    }
  }

  useEffect(() => {
    document.addEventListener('retorik_askedForKioskParametersOpening', (e) => handleChange(e))
    // Dispatch event on mount to get the updated value in stead of the default one
    document.dispatchEvent(new Event('retorik_call_askedForKioskParametersOpening'))

    return () => {
      document.removeEventListener('retorik_askedForKioskParametersOpening', (e) => handleChange(e))
    }
  }, [])

  return current
}

export default useKioskParameterOpening
